import { useState } from "react";
import { Expand } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

const ALT = "SHADC Dispensary October Deals flyer: flower bundles, 14 exotic prerolls for $100, edibles, carts, disposables and concentrates";

export const DealsFlyer = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="container-x mt-10" aria-labelledby="flyer-title" data-testid="deals-flyer-section">
      <div className="card-surface grid items-center gap-8 overflow-hidden p-5 sm:p-8 md:grid-cols-[minmax(0,420px)_1fr]">
        <button type="button" onClick={() => setOpen(true)} className="group relative block overflow-hidden rounded-2xl border border-line" data-testid="deals-flyer-open-button" aria-label="Enlarge October Deals flyer">
          <img src="/deals/october-deals-flyer-sm.webp" alt={ALT} width="512" height="768" className="w-full transition-transform duration-500 group-hover:scale-[1.03]" />
          <span className="absolute bottom-3 right-3 flex items-center gap-2 rounded-full bg-ink/85 px-4 py-2 text-xs font-semibold text-white backdrop-blur"><Expand className="h-4 w-4" aria-hidden />Tap to enlarge</span>
        </button>
        <div>
          <p className="eyebrow">Special deals all month long</p>
          <h2 id="flyer-title" className="mt-2 text-3xl font-semibold text-white sm:text-4xl">October Deals</h2>
          <ul className="mt-5 space-y-2 text-base text-gray-300">
            <li>Flower bundles from <span className="font-semibold text-gold">$140</span></li>
            <li><span className="font-semibold text-gold">14 exotic prerolls for $100</span>, limited time</li>
            <li>Edibles, carts and disposables from <span className="font-semibold text-gold">$100</span></li>
            <li>10g concentrates from <span className="font-semibold text-gold">$220</span></li>
            <li>2 free prerolls with every order</li>
          </ul>
          <a href="#deal-products" className="btn-gold mt-8 inline-flex px-8" data-testid="deals-flyer-shop-button">Shop the deals</a>
        </div>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[95vh] max-w-3xl overflow-y-auto border-line bg-ink p-3" data-testid="deals-flyer-dialog">
          <DialogTitle className="sr-only">October Deals flyer</DialogTitle>
          <img src="/deals/october-deals-flyer.webp" alt={ALT} width="1024" height="1536" className="w-full rounded-xl" />
        </DialogContent>
      </Dialog>
    </section>
  );
};
